import { useCallback } from 'react';

import { ChecklistStep } from './DashboardChecklist.interface';
import DashboardChecklistCard from './DashboardChecklistCard';
import useDashboardChecklistSteps from './useDashboardChecklistSteps';

import {
    LaunchpadItem,
    LaunchpadSubtask,
} from 'modules/common/components/LaunchpadProgress/LaunchpadProgress.interface';
import useStartLaunchpadTask from 'modules/common/components/LaunchpadProgress/useStartLaunchpadTask';

interface DashboardChecklistProps {
    items: LaunchpadItem[];
    onItemClick: (item: LaunchpadItem) => void;
    onSubtaskClick: (subtask: LaunchpadSubtask) => void;
}

function DashboardChecklist({ items, onItemClick, onSubtaskClick }: Readonly<DashboardChecklistProps>) {
    const steps = useDashboardChecklistSteps(items);
    const startTask = useStartLaunchpadTask(onItemClick, onSubtaskClick);

    const handleStart = useCallback((step: ChecklistStep) => startTask(step.nextTask), [startTask]);

    return <DashboardChecklistCard steps={steps} onStart={handleStart} />;
}

export default DashboardChecklist;
